export default function useEmbedMode() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('embed') === 'true';
}
